import { render, staticRenderFns } from "./birthdayReminderList.vue?vue&type=template&id=7890d88a&scoped=true&"
import script from "./birthdayReminderList.vue?vue&type=script&lang=js&"
export * from "./birthdayReminderList.vue?vue&type=script&lang=js&"
import style0 from "./birthdayReminderList.vue?vue&type=style&index=0&id=7890d88a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7890d88a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/01-qym-hop-newmall-frontend-k8s@3/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7890d88a')) {
      api.createRecord('7890d88a', component.options)
    } else {
      api.reload('7890d88a', component.options)
    }
    module.hot.accept("./birthdayReminderList.vue?vue&type=template&id=7890d88a&scoped=true&", function () {
      api.rerender('7890d88a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mass/SOP/components/birthdayReminderList.vue"
export default component.exports